module.exports = __webpack_public_path__ + "static/media/cassette.fd916b8e.png";